/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
// import moduleTodo from './todo/moduleTodo.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js';
import moduleShopDrawings from './shop-drawings/moduleShopDrawings';
import abilityPlugin from './ability';
import moduleTimeline from './timeline/moduleTimeline';
import moduleRfi from './rfi/moduleRfi';
import moduleServiceAppointments from './service-appointments/moduleServiceAppointments';
import moduleServiceAppointmentReport from './service-appointments/reports/moduleServiceAppointmentReports';
import moduleFactoryTests from './factory-tests/moduleFactoryTests';
import moduleTestingSubjects from './factory-tests/testing-subjects/moduleTestingSubjects';
import moduleRequestDurations from './request-durations/moduleRequestDurations';
import modulePrioritySettings from './shop-drawings/priority-settings/modulePrioritySettings';
import moduleCrossCheckingManagement from './cross-checking/moduleCrossCheckingManagement';
import moduleCrossCheckingReportManagement from './cross-checking/report/moduleCrossCheckingReportManagement';
import moduleQualityAssurance from './quality-assurance/moduleQualityAssurance';

Vue.use(Vuex);

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    plugins: [
        abilityPlugin,
    ],
    modules: {
        // todo: moduleTodo,
        // chat: moduleChat,
        // email: moduleEmail,
        auth: moduleAuth,
        shopDrawings: moduleShopDrawings,
        timeline: moduleTimeline,
        rfi: moduleRfi,
        serviceAppointments: moduleServiceAppointments,
        reportModal: moduleServiceAppointmentReport,
        factoryTests: moduleFactoryTests,
        qualityAssurance: moduleQualityAssurance,
        testingSubjects: moduleTestingSubjects,
        requestDurations: moduleRequestDurations,
        prioritySettingsManagement: modulePrioritySettings,
        crosscheckingManagement: moduleCrossCheckingManagement,
        crosscheckingReportManagement: moduleCrossCheckingReportManagement,
    },
    strict: process.env.NODE_ENV !== 'production',
});
